import { Component, Input, OnInit } from '@angular/core';
import { FieldConfig } from '../dynamic-form/dynamic-form-config.interface';
import { FormGroup } from '@angular/forms';
import { CheckboxService } from './checkbox.service';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent implements OnInit {
  @Input() field: FieldConfig;
  @Input() group: FormGroup;

  constructor(private checkboxService: CheckboxService) { }

  onClick(data: any): void {
    this.checkboxService.onClick(data);
  }


  ngOnInit(): void {
  }
}
